module.exports = __webpack_public_path__ + "img/Poker_Chip_Green.d55b05c6.svg";